import React from 'react';
import DynamicPage from '../components/DynamicPage';

const EventsPage: React.FC = () => {
  return (
    <DynamicPage 
      pageType="events"
      title=""
      backButtonText="Back to Home"
    />
  );
};

export default EventsPage;
